import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CreateInventoryInfo, SubCategory } from '@usf/inventory-types';

@Component({
  selector: 'app-populate-inventory-options',
  templateUrl: './populate-inventory-options.component.html',
  styleUrls: ['./populate-inventory-options.component.scss'],
})
export class PopulateInventoryOptionsComponent {
  @Input() inventoryConstants: CreateInventoryInfo;
  @Input() selectedCreateInventoryOption: SubCategory;
  @Output()
  selectCreateInventoryOptionEmitter: EventEmitter<SubCategory> = new EventEmitter();

  constructor() {}

  handleCreateInventoryOptionSelection(
    selectedCreateInventoryOption: SubCategory,
  ) {
    this.selectedCreateInventoryOption = selectedCreateInventoryOption;
    this.selectCreateInventoryOptionEmitter.emit(selectedCreateInventoryOption);
  }
}
